import React, { useState, useEffect } from 'react';
import { Button, Container } from '@mui/material';
import { Form, Col, Row, Tab, Nav } from 'react-bootstrap';
import Swal from 'sweetalert2';
import "./Report.css";
import "../../assets/css/custom.css";
import ReportMap from './ReportMap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import "./trips.css";
import { baseURL } from '../base_url';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import { format } from 'date-fns';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';

const Trips = () => {

  const getSevenDaysAgo = () => {
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    return sevenDaysAgo;
  };
  const defaultFromDate = getSevenDaysAgo();
  const defaultToDate = new Date();

  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [toDate, setToDate] = useState(defaultToDate);
  const [selectedFromDate, setSelectedFromDate] = useState(new Date(new Date().setDate(new Date().getDate() - 3)));
  const [selectedToDate, setSelectedToDate] = useState(new Date());
  const [showMapDiv, setShowMapDiv] = useState(false);
  const [vinNumber, setVinNumber] = useState("");
  const [raNumber, setraNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [tripDataList,setTripDataList] = useState([]);
  const [autoSubmit, setAutoSubmit] = useState(false);
  const [locationId, setLocationID] = useState('');

  const [searchParams] = useSearchParams();
  const hasAnyParams = searchParams.toString().length > 0;
  useEffect(() => {
    if (hasAnyParams) {
      const vin = searchParams.get('vin');
      setVinNumber(vin);
      setActiveTab("search_vin"); // Automatically select "Search By VIN" tab
      setAutoSubmit(true);
    }
  }, [hasAnyParams, searchParams]);

  useEffect(() => {
    if (autoSubmit && vinNumber) {
      handleSubmitButton('vin');
      setAutoSubmit(false); // Reset the flag to prevent repeated submissions
    }
  }, [vinNumber, autoSubmit]);

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const locationTimezones = {
    '6': 'America/Denver',
    '20': 'America/Denver',
    '3': 'America/New_York',
    '5': 'America/New_York',
    '4': 'America/Chicago',
    '2': 'America/Toronto', 
    '1': 'America/Edmonton',
    '7': 'America/Vancouver',
    '9': 'America/Toronto',
    '8': 'America/Toronto',
    '12': 'America/Toronto',
    '21': 'Asia/Dubai'
  };

  const vinPattern = /^[A-HJ-NPR-Z0-9]{17}$/; 

  const handleVinNumber = (vin) => {
    setVinNumber(vin)
    // if (vinPattern.test(vin)) {
    //   const location = await getLocationFromVin(vin); 
    //   if(location)
    //   {
    //     setLocationID(location['location_id'])
    //     const timezone = locationTimezones[location['location_id']];
    //     if (timezone) {
    //       setFromDate(moment(fromDate).tz(timezone).toDate());
    //       setToDate(moment(toDate).tz(timezone).toDate());
    //     }
    //   }
    // }
  }

  async function getLocationFromVin(vin) {
    try {
      const response = await fetch(baseURL + '/get_location_by_vin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ vin }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch location');
      }
  
      const data = await response.json();
      return data.location;
    } catch (error) {
      console.error('Error fetching location:', error);
      return 'Unknown';
    }
  }

  const handleraNumber = (vin) => {
    setraNumber(vin)
  }
  const handleSubmitButton = (type) => {
    if (type === "vin" && vinNumber === "")
    {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please enter the VIN Number',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (type === "vin" && (fromDate === "" || fromDate === null))
    {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please select From Date',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    } 
    if (type === "vin" && (toDate === "" || toDate === null))
    {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please select To Date',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (type === "vin" && (toDate < fromDate)) 
    {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'To Date cannot be less than From Date',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (type === "ra" && raNumber === "")
    {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please enter the R/A Number',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    setLoading(true);
    setShowMapDiv(false) 

    // let formattedFromDateTime = 0;
    // let formattedToDateTime = 0;

    // if(type == 'ra')
    // {
    //   formattedFromDateTime = fromDate.toISOString();
    //   formattedToDateTime = toDate.toISOString();
    // }
    // else
    // {
    //   const timezone = locationTimezones[locationId]; // e.g., 'America/Toronto'
    //   formattedFromDateTime = moment(fromDate).tz(timezone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
    //   formattedToDateTime = moment(toDate).tz(timezone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
    // }

    // const formattedFromDateTime = new Date(selectedFromDate).toLocaleString()
    // const formattedToDateTime = new Date(selectedToDate).toDateString()

    const formattedFromDateTime = format_dates(selectedFromDate)
    const formattedToDateTime = format_dates(selectedToDate)
    axios.post(baseURL + "/get_trip_data_by_vin", {
      'vin_number': vinNumber,
      'from_date': formattedFromDateTime,
      'to_date': formattedToDateTime,
      'ra': raNumber,
      'search_type': type
    })
    .then((res2) => { 
      if (res2.data.status == '1'){
        setLoading(false);
        setTripDataList(res2.data.data)
        setShowMapDiv(true)
      }else{
        setLoading(false);
        setTripDataList([])
        setShowMapDiv(false)
        Swal.fire({
          position: 'middle',
          icon: 'info',
          title: 'No Trips found for selected dates',
          showConfirmButton: false,
          timer: 3000
        })
        return;
      }
    }); 
  }

  function format_dates(selectedDate) 
  {
    const formattedFromDateTime = new Date(selectedDate).toLocaleString('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // 24-hour format
        timeZone: 'Asia/Kolkata', // Ensure consistent timezone
    }).replace(/:\d{2} /, ':00 ');

    return formattedFromDateTime

  }
  const formatDate = (date) => {
    const date1 = new Date(date);
    return format(date1, 'MM/dd/yyyy HH:mm');
  };
  const [activeTab, setActiveTab] = useState('search_ra');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setShowMapDiv(false); // Hide map when changing tabs
  };
  return(
      <div className='body_class'>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
        <div className="d-flex justify-content-between align-items-center mb-4" style={{ marginLeft: '4px', marginRight: '4px' }}>
          <h4>Trips History</h4>
        </div>
        <div className='container-fluid'>
          <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="search_ra">Search By Agreement</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="search_vin">Search By VIN</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="search_ra">
                <div className='row'>
                  <div className='col-12'>
                    <Form.Group as={Row} className="mt-1" controlId="formPlaintextCountry">
                        <Form.Label column sm="auto">R/A:</Form.Label>
                        <Col sm="auto">
                          <input type="text" placeholder="Enter R/A" className="form-control customInputBox" value={raNumber} id="raNumber" onChange={(e) => handleraNumber(e.target.value)} />
                        </Col>
                        <Col sm="auto">
                          <Button variant="contained" type="submit" onClick={(e) => handleSubmitButton('ra')}>Search</Button>
                        </Col>
                    </Form.Group>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="search_vin">
                <div className='row'>
                  <div className='col-12'>
                    <Form.Group as={Row} className="mt-1" controlId="formPlaintextCountry">
                        <Form.Label column sm="auto">From:</Form.Label>
                        <Col sm="auto">
                          {/* <DatePicker 
                            selected={fromDate}
                            onChange={handleFromDateChange} 
                            maxDate={toDate} 
                            showTimeSelect 
                            timeFormat="HH:mm" 
                            timeIntervals={15} 
                            timeCaption="Time" 
                            dateFormat="MM/dd/yyyy h:mm aa"
                          /> */}
                          <DatePicker
                            id="datepicker"
                            selected={selectedFromDate}
                            onChange={(date) => setSelectedFromDate(date)}
                            className="form-control" // Bootstrap class for input fields
                            maxDate={selectedToDate}
                            showTimeSelect 
                            timeFormat="HH:mm" 
                            timeIntervals={15} 
                            timeCaption="Time" 
                            dateFormat="MM/dd/yyyy h:mm aa"
                          />
                        </Col>
                        <Form.Label column sm="auto">To:</Form.Label>
                        <Col sm="auto">
                          {/* <DatePicker 
                            selected={toDate} 
                            onChange={handleToDateChange} 
                            minDate={fromDate} 
                            showTimeSelect 
                            timeFormat="HH:mm" 
                            timeIntervals={15} 
                            timeCaption="Time" 
                            dateFormat="MM/dd/yyyy h:mm aa"
                          /> */}
                          <DatePicker
                            id="datepicker"
                            selected={selectedToDate}
                            onChange={(date) => setSelectedToDate(date)}
                            className="form-control" // Bootstrap class for input fields
                            minDate={selectedFromDate}
                            showTimeSelect 
                            timeFormat="HH:mm" 
                            timeIntervals={15} 
                            timeCaption="Time" 
                            dateFormat="MM/dd/yyyy h:mm aa"
                          />
                        </Col>
                        <Form.Label column sm="auto">VIN Number:</Form.Label>
                        <Col sm="auto">
                          <input type="text" placeholder="Enter VIN Number" className="form-control customInputBox" value={vinNumber} id="vinNumber" onChange={(e) => handleVinNumber(e.target.value)} />
                        </Col>
                        <Col sm="auto">
                          <Button variant="contained" type="submit" onClick={(e) => handleSubmitButton('vin')}>Search</Button>
                        </Col>
                    </Form.Group>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
          {/* Map Div */}
          {showMapDiv && (
            <div className='p-1 mt-3 madatory_fields custom_monitor_screen'>
              <div className='row' style={{minHeight:"8vh"}}>
                <div className='col-12'>
                  <div className='row' >
                    <ReportMap tripData={tripDataList}/>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
}

export default Trips;